module.exports = __webpack_public_path__ + "img/new-tab.955ca457.png";